<template>
  <v-btn icon dark>
    <v-icon v-text="$vuetify.icons.values.help" />
  </v-btn>
</template>

<script>
export default {}
</script>
